// 2026-07-02 US-003
import { notification } from 'antd';
import { APIResponseCode, MessageDisplay } from 'common/constants';
import { GetNotificationProps } from 'common/utils/utility';
import { APIResponse, PostData } from 'common/utils/jsonFetch';
import { KFSEndpoints } from 'common/constants/KFSEndpoints';
import { Validator } from 'common/validators/validators';
import {
  BatchDetailResponse,
  GetRecipientsRequest,
  GetRecipientsResponse,
  HistoryItem,
  SendRequest,
  SendResponse,
} from 'common/models/BulkNotificationTypes';
import { HandleErrorMessage } from '@features/Common';
import { BulkNotificationsActions } from '../store/BulkNotificationsSlice';

export const GetBulkNotificationRecipients = (request: GetRecipientsRequest) => async (dispatch) => {
  const methodName = 'GetBulkNotificationRecipients';

  try {
    dispatch(BulkNotificationsActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.BulkNotification_GetRecipients, request);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const data: GetRecipientsResponse = response.parsedBody?.Results;
    dispatch(BulkNotificationsActions.SetRecipientsResponse(data));
    dispatch(BulkNotificationsActions.submitStatusSucceeded());
    // 2026-07-02 US-003: return the parsed response so callers (e.g. the "Check
    // recipients" handler) can branch on IsValid / InvalidRefNumbers synchronously
    // instead of relying on a re-render to see the freshly-dispatched Redux state.
    return data;
  } catch (e) {
    dispatch(BulkNotificationsActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    return undefined;
  }
};

export const SendBulkNotification = (request: SendRequest) => async (dispatch) => {
  const methodName = 'SendBulkNotification';

  try {
    dispatch(BulkNotificationsActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.BulkNotification_Send, request);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const data: SendResponse = response.parsedBody?.Results;
    dispatch(BulkNotificationsActions.SetSendResponse(data));
    dispatch(BulkNotificationsActions.submitStatusSucceeded());
    return data;
  } catch (e) {
    dispatch(BulkNotificationsActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    return undefined;
  }
};

export const GetBulkNotificationSendHistory = () => async (dispatch) => {
  const methodName = 'GetBulkNotificationSendHistory';

  try {
    dispatch(BulkNotificationsActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.BulkNotification_GetSendHistory, {});
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const data: HistoryItem[] = response.parsedBody?.Results || [];
    dispatch(BulkNotificationsActions.SetHistory(data));
    dispatch(BulkNotificationsActions.submitStatusSucceeded());
    return data;
  } catch (e) {
    dispatch(BulkNotificationsActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    return undefined;
  }
};

export const GetBulkNotificationSendBatchDetail = (sendId: string) => async (dispatch) => {
  const methodName = 'GetBulkNotificationSendBatchDetail';

  try {
    dispatch(BulkNotificationsActions.submitStatus());
    const response = await PostData<APIResponse>(KFSEndpoints.BulkNotification_GetSendBatchDetail, sendId);
    new Validator(response.parsedBody?.Status).IsEqualsString(APIResponseCode.SUCCESS);
    const data: BatchDetailResponse = response.parsedBody?.Results;
    dispatch(BulkNotificationsActions.SetBatchDetail(data));
    dispatch(BulkNotificationsActions.submitStatusSucceeded());
    return data;
  } catch (e) {
    dispatch(BulkNotificationsActions.submitStatusRejected(HandleErrorMessage(methodName, e)));
    notification.error(GetNotificationProps(MessageDisplay.GENERIC_TECHNICAL_ERROR));
    return undefined;
  }
};
